import { CardProvider } from 'context/cards/cardContext';
import CardSection from '../components/CardsSection/CardSection';
import { Box } from '@mui/material';

export const CardsPage = () => {
    return (
        <CardProvider>
            <Box minHeight="88vh">
                <CardSection />
            </Box>
        </CardProvider>
    );
};
